import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;
        const hash = location.hash || window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;
        (async () => {
            if (!sessionId) {
                navigate("/login");
                return;
            }
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data);
                window.history.replaceState(null, "", "/account");
                navigate("/account", { state: { user: data } });
            } catch {
                navigate("/login");
            }
        })();
    }, [location, navigate, setUser]);

    return (
        <div className="min-h-screen grid place-items-center bg-cream-50">
            <div className="text-center">
                <div className="mx-auto h-10 w-10 rounded-full border-2 border-caramel border-t-transparent animate-spin" />
                <p className="mt-4 font-serif text-xl text-roast">Sweetening your session…</p>
            </div>
        </div>
    );
}
